import EpicTemplateComp from "../components/EpicTemplateComp";
import React, { useEffect, useState } from "react";
import { LIMIT } from "../../notes-fhir/constent/ConstentVariable";
import { fetchQuery } from "../../../actions";
import { GET_NOTES_TEMPLATES_DATA } from "../../notes-fhir/actions/notesAct";
import { errorToDisplay } from "../../../helper/CommonFuncs";
import { ShowAlert } from "../../../common/alert";

const EpicTemplateCont = ({ handleRadioChange }) => {
   const [templatesContent, setTemplatesContent] = useState({
      list: [],
      loading: true,
      notesTemplate: { limit: LIMIT, offset: 0, enabledTemplate: false },
   });
   const getNotesTemplate = (showLoader = true) => {
      if (showLoader) {
         setTemplatesContent({ ...templatesContent, loading: true });
      }
      let obj = {};
      let notesTemplate = {
         limit: 50,
         offset: 0,
         enabledTemplate: true,
      };
      obj.notesTemplate = notesTemplate;
      fetchQuery(
         GET_NOTES_TEMPLATES_DATA,
         obj,
         (res) => {
            const contentData = res?.data?.getNotesTemplate?.template || [];
            const totalResults = contentData;
            setTemplatesContent({
               ...templatesContent,
               list: totalResults,
               loading: false,
               offset: null,
            });
         },
         (err) => {
            ShowAlert(errorToDisplay(err), "error");
            setTemplatesContent({ ...templatesContent, loading: false });
         }
      );
   };

   useEffect(() => {
      getNotesTemplate();
   }, []);
   return (
      <EpicTemplateComp
         handleRadioChange={handleRadioChange}
         templatesContent={templatesContent}
         getNotesTemplate={getNotesTemplate}
      />
   );
};

export default EpicTemplateCont;
